import axios from 'axios';
import { API_URL } from './tokens';

const http = axios.create({
  baseURL: API_URL });

http.interceptors.request.use(cfg => {
  const t = localStorage.getItem('sf_parent');
  if (t && cfg.headers)
    cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

http.interceptors.response.use(
  r => r,
  err => {
    if (err.response?.status === 401) {
      localStorage.clear();
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export const api = {
  pin: (pin: string) =>
    http.post('/auth/pin', { pin }),
  setup: (d: any) =>
    http.post('/auth/setup', d),
  children: () => http.get('/children'),
  createChild: (d: any) =>
    http.post('/children', d),
  habits: (cid: string) =>
    http.get(`/children/${cid}/habits`),
  createHabit: (cid: string, d: any) =>
    http.post(`/children/${cid}/habits`, d),
  deleteHabit: (id: string) =>
    http.delete(`/habits/${id}`),
  progress: () =>
    http.get('/family/progress'),
  goals: () =>
    http.get('/family/goals'),
  createGoal: (d: any) =>
    http.post('/family/goals', d),
  updateGoal: (id: string, d: any) =>
    http.patch(`/family/goals/${id}`, d),
  rewards: () =>
    http.get('/family/rewards'),
  createReward: (d: any) =>
    http.post('/family/rewards', d),
  pending: () =>
    http.get('/family/redemptions/pending'),
  resolve: (id: string, status: string,
      note?: string) =>
    http.patch(`/family/redemptions/${id}`,
      { status, parent_note: note }),
  jars: (cid: string) =>
    http.get(`/children/${cid}/jars`),
  sendNote: (cid: string, msg: string) =>
    http.post(`/children/${cid}/notes`,
      { message: msg }),
  reportCard: () =>
    http.get('/family/report-card'),
};

export default http;
